<template>
  <v-card>
    <v-card-text>
      <v-row>
        <v-col>
          <v-card
            tile
            style="max-height: 30vh;overflow-y: auto;"
          >
            <v-card-text>
              <v-data-table
                :headers="tableHeaders"
                :items="manifestFinalDisposals"
                disable-sort
                hide-default-footer
              >
                <template v-slot:[`item.final_disposal_date`]="{item}">
                  {{ item.final_disposal_date | date_format }}
                </template>
                <template v-slot:[`item.disposal_site`]="{item}">
                  {{ item.name }}
                  <v-tooltip
                    top
                    :open-on-hover="false"
                  >
                    <template #activator="{ on }">
                      <v-btn
                        v-if="item.address"
                        icon
                        small
                        retain-focus-on-click
                        @click="on.click"
                        @blur="on.blur"
                      >
                        <v-icon small>
                          mdi-map-marker-outline
                        </v-icon>
                      </v-btn>
                    </template>
                    <small
                      v-if="item.address"
                    >
                      {{ item.address }}
                    </small>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>

    <!-- 再資源化等の情報詳細 -->
    <template v-if="showRecycleDisposalReport">
      <v-card-title>
        <span style="color: #0074BA">再資源化等の情報詳細</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="3">
            <div class="overline">
              基準重量
            </div>
            <h4>
              {{ manifest.reported_standard_quantity_type_name || '-' }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="3">
            <div class="overline">
              重量
            </div>
            <h4>
              {{ manifest.reported_quantity ? `${manifest.reported_quantity}kg` : '-' }}
            </h4>
            <v-divider />
          </v-col>
        </v-row>
        <div class="mt-2">
          <recycle-step-table
            :headers="headers"
            :result-list="manifest.manifest_recycle_disposal_reports || []"
            :reference-only="true"
          />
        </div>
      </v-card-text>
    </template>
    <!-- /再資源化等の情報詳細 -->
  </v-card>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'ModifyFinalDisposalReportForm',
  components: {},
  mixins: [],
  props: {
    manifestFinalDisposals: {
      type: Array,
      default: () => [],
    },
    manifest: {
      type: Object,
      default: () => ({}),
    }
  },
  data() {
    return {
      tableHeaders: [
        { value: 'final_disposal_date', text: '最終処分終了日' },
        { value: 'disposal_site', text: '最終処分事業場' }
      ],
      headers: [
        {value: "level", text: "工程", width: "6%"},
        {value: "disposer", text: "処分事業者\r\n処分事業場\r\n住所", width: "15%"},
        {value: "report_before_disposal_weight", text: "処分前重量", width: "6%"},
        {value: "primary_disposal_method", text: "処分方法", width: "15%"},
        {value: "report_after_disposal_weight", text: "処理後重量", width: "6%"},
        {value: "recycle_disposed_item", text: "処理後物の大分類\r\n処理後物の種類", width: "17%"},
        {value: "final_disposal", text: "最終処分", width: "10%"},
        {value: "input_final_disposal_date", text: "最終処分終了日", width: "10%"},
        {value: "comment", text: "備考", width: "10%"},
      ],
    }
  },
  computed: {
    ...mapState('DriverTenantConfiguration', {
      mode: 'mode',
    }),
    /**
     * 再資源化等の情報詳細の表示判定
     */
    showRecycleDisposalReport() {
      return (this.mode === 'transport_disposal' || this.mode === 'disposal') && this.manifest.manifest_recycle_disposal_reports.some(
        report => report.report_type === 'final_disposal_report'
      )
    }
  },
  watch: {},
  created() {},
  methods: {}
}
</script>
